import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ShowUnavailableProductsState {
  showUnavailableProducts: boolean;
  toggle: () => void;
}

export const useShowUnavailableProductsStore = create<ShowUnavailableProductsState>()(
  persist(
    (set, get) => ({
      showUnavailableProducts: true,

      toggle: () => {
        set({ showUnavailableProducts: !get().showUnavailableProducts });
      },
    }),
    { name: 'show-unavailable-products' },
  ),
);
